"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var cross_fetch_1 = require("cross-fetch");
var node_abort_controller_1 = require("node-abort-controller");
var Errors_1 = require("./Errors");
var RetryPolicy_1 = require("./RetryPolicy");
var RestApiConnector = /** @class */ (function () {
    function RestApiConnector(authManager) {
        this.authManager = authManager;
    }
    RestApiConnector.prototype.request = function (requestOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, method, _b, authenticated, _c, apiExpectsFormData, _d, admin, path, body, headersFromOptions, params, retryPolicyFromOptions, _e, timeoutMs, retryPolicy, authState, url, controller_1, options, headers, authOptions, _f, newToken, newAuthState, _g, newToken, newAuthState, timeoutTimeoutId, response, data, parsedData, parsedErrorData, firstAttemptError_1, retries, error, subsequentAttemptError_1;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _a = requestOptions.method, method = _a === void 0 ? "GET" : _a, _b = requestOptions.authenticated, authenticated = _b === void 0 ? true : _b, _c = requestOptions.apiExpectsFormData, apiExpectsFormData = _c === void 0 ? false : _c, _d = requestOptions.admin, admin = _d === void 0 ? false : _d, path = requestOptions.path, body = requestOptions.body, headersFromOptions = requestOptions.headers, params = requestOptions.params, retryPolicyFromOptions = requestOptions.retryPolicy, _e = requestOptions.timeoutMs, timeoutMs = _e === void 0 ? 15000 : _e;
                        retryPolicy = retryPolicyFromOptions ||
                            (authenticated ? new RetryPolicy_1.AuthenticatedRequestRetryPolicy() : new RetryPolicy_1.RetryPolicy());
                        authState = this.authManager.getState();
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 14, , 24]);
                        url = requestOptions.url;
                        if (!url && !path) {
                            throw new Errors_1.ValidationError("Request options \"url\" or \"path\" must be provided.");
                        }
                        if (url && path) {
                            throw new Errors_1.ValidationError("You may only provide a \"url\" or a \"path\".");
                        }
                        if (url && !/^https?:\/\//.test(url)) {
                            throw new Errors_1.ValidationError("Request option \"url\" must include protocol.");
                        }
                        if (path && !/^\//.test(path)) {
                            throw new Errors_1.ValidationError("Request option \"path\" must include leading slash.");
                        }
                        controller_1 = new node_abort_controller_1.AbortController();
                        options = {
                            method: method,
                            mode: "cors",
                            referrerPolicy: "no-referrer",
                            signal: controller_1.signal
                        }, headers = {}, authOptions = this.authManager.getOptions();
                        if (!authenticated) return [3 /*break*/, 11];
                        if (!(authState.authenticated && authState.access_token)) return [3 /*break*/, 8];
                        if (!(+(new Date(authState.expires_at)) < Date.now())) return [3 /*break*/, 6];
                        if (!authState.no_refresh) return [3 /*break*/, 2];
                        throw new Errors_1.UnauthenticatedError("Token refresh required before making request. Try Chariot.refreshLogin({ refresh_token }).");
                    case 2:
                        if (!(!authState.refreshing_now && authState.refresh_token)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshLogin({ refresh_token: authState.refresh_token })];
                    case 3:
                        authState = _h.sent();
                        _h.label = 4;
                    case 4: return [4 /*yield*/, this.authManager.waitForNextToken()];
                    case 5:
                        _f = _h.sent(), newToken = _f[0], newAuthState = _f[1];
                        authState = newAuthState;
                        headers["Authorization"] = "Bearer ".concat(newToken);
                        return [3 /*break*/, 7];
                    case 6:
                        headers["Authorization"] = "Bearer ".concat(authState.access_token);
                        _h.label = 7;
                    case 7: return [3 /*break*/, 11];
                    case 8:
                        if (!authOptions.allowAuthenticatedRequestsBeforeAuthentication) return [3 /*break*/, 9];
                        throw new Errors_1.UnauthenticatedError("Attempted to make an authenticated request before logging in. Try Chariot.login({ email, password }).");
                    case 9: return [4 /*yield*/, this.authManager.waitForNextToken()];
                    case 10:
                        _g = _h.sent(), newToken = _g[0], newAuthState = _g[1];
                        authState = newAuthState;
                        headers["Authorization"] = "Bearer ".concat(newToken);
                        _h.label = 11;
                    case 11:
                        if (body) {
                            if (apiExpectsFormData) {
                                options.body = Object.keys(body).reduce(function (formData, key) {
                                    formData.append(key, body[key]);
                                    return formData;
                                }, new FormData());
                            }
                            else {
                                options.body = JSON.stringify(body);
                                headers["Content-Type"] = "application/json";
                            }
                        }
                        if (!url) {
                            if (authOptions.cors || admin) {
                                url = "https://api.fsgchariot.app".concat(path);
                                if (admin) {
                                    headers["x-chariot-admin"] = "true";
                                }
                                else {
                                    headers["x-chariot-host"] = authOptions.domain;
                                }
                            }
                            else {
                                url = "https://".concat(authOptions.domain, "/api").concat(path);
                            }
                        }
                        options.headers = __assign(__assign({}, headers), headersFromOptions);
                        if (params && Object.keys(params).length > 0) {
                            url += "?".concat(Object.keys(params)
                                .filter(function (o) { return params[o] !== undefined && params[o] !== null; })
                                .map(function (o) { return "".concat(o, "=").concat(params[o]); })
                                .join("&"));
                        }
                        timeoutTimeoutId = setTimeout(function () { return controller_1.abort(); }, timeoutMs);
                        return [4 /*yield*/, (0, cross_fetch_1.default)(url, options)];
                    case 12:
                        response = _h.sent();
                        clearTimeout(timeoutTimeoutId);
                        if (response.status == 401) {
                            throw new Errors_1.UnauthenticatedError();
                        }
                        else if (response.status == 403) {
                            throw new Errors_1.UnauthorizedError();
                        }
                        return [4 /*yield*/, response.text()];
                    case 13:
                        data = _h.sent();
                        parsedData = void 0;
                        try {
                            if (response.status == 204) {
                                parsedData = {};
                            }
                            else {
                                parsedData = JSON.parse(data);
                            }
                        }
                        catch (e) {
                            if (response.status < 400)
                                throw new Errors_1.ResponseParseError();
                            parsedData = { message: "" };
                        }
                        if (response.status >= 400 && response.status < 600) {
                            parsedErrorData = parsedData;
                            if (response.status == 400 || response.status == 422) {
                                throw new Errors_1.ValidationError(parsedErrorData.message);
                            }
                            if (response.status == 404) {
                                throw new Errors_1.EntityNotFoundError(parsedErrorData.message);
                            }
                            throw new Errors_1.InternalServerError(parsedErrorData.message);
                        }
                        return [2 /*return*/, parsedData];
                    case 14:
                        firstAttemptError_1 = _h.sent();
                        retries = 0, error = firstAttemptError_1;
                        if (error.name == "AbortError")
                            error = new Errors_1.RequestTimeoutError();
                        _h.label = 15;
                    case 15:
                        if (!(retries < retryPolicy.maxRetries)) return [3 /*break*/, 23];
                        return [4 /*yield*/, retryPolicy.readyToRetry(error, this, this.authManager)];
                    case 16:
                        if (!_h.sent()) return [3 /*break*/, 21];
                        _h.label = 17;
                    case 17:
                        _h.trys.push([17, 19, , 20]);
                        return [4 /*yield*/, this.request(__assign(__assign({}, requestOptions), { retryPolicy: new RetryPolicy_1.RetryPolicy({ maxRetries: 0 }) }))];
                    case 18: return [2 /*return*/, _h.sent()];
                    case 19:
                        subsequentAttemptError_1 = _h.sent();
                        error = subsequentAttemptError_1;
                        return [3 /*break*/, 20];
                    case 20:
                        retries += 1;
                        return [3 /*break*/, 22];
                    case 21: return [3 /*break*/, 23];
                    case 22: return [3 /*break*/, 15];
                    case 23: throw error;
                    case 24: return [2 /*return*/];
                }
            });
        });
    };
    RestApiConnector.prototype.login = function (_a) {
        var email = _a.email, password = _a.password, token = _a.token;
        return __awaiter(this, void 0, void 0, function () {
            var authResponse, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.authManager.setState({
                            refreshing_now: true
                        }, false);
                        if (!(email && password && !token)) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request({
                                method: "POST",
                                authenticated: false,
                                path: "/login",
                                body: {
                                    email: email,
                                    password: password
                                }
                            })];
                    case 2:
                        authResponse = _b.sent();
                        this.authManager.setState({
                            authenticated: true,
                            access_token: authResponse.access_token,
                            refresh_token: authResponse.refresh_token,
                            expires_at: authResponse.expires_at,
                            refreshing_now: false,
                            no_refresh: false
                        });
                        return [2 /*return*/, this.authManager.getState()];
                    case 3:
                        e_1 = _b.sent();
                        this.authManager.setState({
                            refreshing_now: false
                        }, false);
                        throw e_1;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        if (token && !email && !password) {
                            this.authManager.setState({
                                authenticated: true,
                                access_token: token,
                                refresh_token: "",
                                expires_at: "9999-99-99",
                                refreshing_now: false,
                                no_refresh: true
                            });
                            return [2 /*return*/, this.authManager.getState()];
                        }
                        else {
                            throw new Errors_1.ValidationError("Must provide either email and password combination OR an access token to log in.");
                        }
                        _b.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    RestApiConnector.prototype.refreshLogin = function (_a) {
        var refresh_token = _a.refresh_token;
        return __awaiter(this, void 0, void 0, function () {
            var authResponse, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.authManager.setState({
                            refreshing_now: true
                        }, false);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request({
                                method: "POST",
                                authenticated: false,
                                path: "/refresh",
                                body: {
                                    refresh_token: refresh_token
                                }
                            })];
                    case 2:
                        authResponse = _b.sent();
                        this.authManager.setState({
                            authenticated: true,
                            access_token: authResponse.access_token,
                            refresh_token: authResponse.refresh_token,
                            expires_at: authResponse.expires_at,
                            refreshing_now: false,
                            no_refresh: false
                        });
                        return [2 /*return*/, this.authManager.getState()];
                    case 3:
                        e_2 = _b.sent();
                        this.authManager.resetState();
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RestApiConnector.prototype.unfurlAtlasPagination = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var page_size, page, total_pages, combinedResults, _a, total_count, results;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        page_size = options.params && options.params.page_size ? options.params.page_size : 25;
                        page = 1, combinedResults = [];
                        _b.label = 1;
                    case 1:
                        if (!(total_pages == undefined || page <= total_pages)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.request(__assign(__assign({}, options), { params: __assign(__assign({}, options.params), { page: page, page_size: page_size }), retryPolicy: new RetryPolicy_1.AuthenticatedPaginatedRequestRetryPolicy() }))];
                    case 2:
                        _a = _b.sent(), total_count = _a.total_count, results = _a.results;
                        combinedResults = combinedResults.concat(results);
                        total_pages = Math.ceil(total_count / page_size);
                        page += 1;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, combinedResults];
                }
            });
        });
    };
    RestApiConnector.prototype.iterateAtlasPagination = function (options) {
        return __asyncGenerator(this, arguments, function iterateAtlasPagination_1() {
            var page_size, page, total_pages, combinedResults, _a, total_count, results, _i, results_1, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        page_size = options.params && options.params.page_size ? options.params.page_size : 25;
                        page = 1, combinedResults = [];
                        _b.label = 1;
                    case 1:
                        if (!(total_pages == undefined || page <= total_pages)) return [3 /*break*/, 8];
                        return [4 /*yield*/, __await(this.request(__assign(__assign({}, options), { params: __assign(__assign({}, options.params), { page: page, page_size: page_size }), retryPolicy: new RetryPolicy_1.AuthenticatedPaginatedRequestRetryPolicy() })))];
                    case 2:
                        _a = _b.sent(), total_count = _a.total_count, results = _a.results;
                        _i = 0, results_1 = results;
                        _b.label = 3;
                    case 3:
                        if (!(_i < results_1.length)) return [3 /*break*/, 7];
                        result = results_1[_i];
                        return [4 /*yield*/, __await(result)];
                    case 4: return [4 /*yield*/, _b.sent()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 3];
                    case 7:
                        combinedResults = combinedResults.concat(results);
                        total_pages = Math.ceil(total_count / page_size);
                        page += 1;
                        return [3 /*break*/, 1];
                    case 8: return [4 /*yield*/, __await(combinedResults)];
                    case 9: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    RestApiConnector.prototype.unfurlRuleApiPagination = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var count, page, total_pages, combinedResults, _a, total_count, results;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        count = options.params && options.params.count ? options.params.count : 25;
                        page = 1, combinedResults = [];
                        _b.label = 1;
                    case 1:
                        if (!(total_pages == undefined || page <= total_pages)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.request(__assign(__assign({}, options), { params: __assign(__assign({}, options.params), { page: page, count: count }), retryPolicy: new RetryPolicy_1.AuthenticatedPaginatedRequestRetryPolicy() }))];
                    case 2:
                        _a = _b.sent(), total_count = _a.total_count, results = _a.results;
                        combinedResults = combinedResults.concat(results);
                        total_pages = Math.ceil(total_count / count);
                        page += 1;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, combinedResults];
                }
            });
        });
    };
    RestApiConnector.prototype.iterateRuleApiPagination = function (options) {
        return __asyncGenerator(this, arguments, function iterateRuleApiPagination_1() {
            var count, page, total_pages, combinedResults, _a, total_count, results, _i, results_2, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        count = options.params && options.params.count ? options.params.count : 25;
                        page = 1, combinedResults = [];
                        _b.label = 1;
                    case 1:
                        if (!(total_pages == undefined || page <= total_pages)) return [3 /*break*/, 8];
                        return [4 /*yield*/, __await(this.request(__assign(__assign({}, options), { params: __assign(__assign({}, options.params), { page: page, count: count }), retryPolicy: new RetryPolicy_1.AuthenticatedPaginatedRequestRetryPolicy() })))];
                    case 2:
                        _a = _b.sent(), total_count = _a.total_count, results = _a.results;
                        _i = 0, results_2 = results;
                        _b.label = 3;
                    case 3:
                        if (!(_i < results_2.length)) return [3 /*break*/, 7];
                        result = results_2[_i];
                        return [4 /*yield*/, __await(result)];
                    case 4: return [4 /*yield*/, _b.sent()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 3];
                    case 7:
                        combinedResults = combinedResults.concat(results);
                        total_pages = Math.ceil(total_count / count);
                        page += 1;
                        return [3 /*break*/, 1];
                    case 8: return [4 /*yield*/, __await(combinedResults)];
                    case 9: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    RestApiConnector.prototype.unfurlIdentityApiPagination = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var page_size, page, total_pages, combinedResults, _a, count, results;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        page_size = options.params && options.params.page_size ? options.params.page_size : 25;
                        page = 1, combinedResults = [];
                        _b.label = 1;
                    case 1:
                        if (!(total_pages == undefined || page <= total_pages)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.request(__assign(__assign({}, options), { params: __assign(__assign({}, options.params), { page: page, page_size: page_size }), retryPolicy: new RetryPolicy_1.AuthenticatedPaginatedRequestRetryPolicy() }))];
                    case 2:
                        _a = _b.sent(), count = _a.count, results = _a.results;
                        combinedResults = combinedResults.concat(results);
                        total_pages = Math.ceil(count / page_size);
                        page += 1;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, combinedResults];
                }
            });
        });
    };
    RestApiConnector.prototype.iterateIdentityApiPagination = function (options) {
        return __asyncGenerator(this, arguments, function iterateIdentityApiPagination_1() {
            var page_size, page, total_pages, combinedResults, _a, count, results, _i, results_3, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        page_size = options.params && options.params.page_size ? options.params.page_size : 25;
                        page = 1, combinedResults = [];
                        _b.label = 1;
                    case 1:
                        if (!(total_pages == undefined || page <= total_pages)) return [3 /*break*/, 8];
                        return [4 /*yield*/, __await(this.request(__assign(__assign({}, options), { params: __assign(__assign({}, options.params), { page: page, page_size: page_size }), retryPolicy: new RetryPolicy_1.AuthenticatedPaginatedRequestRetryPolicy() })))];
                    case 2:
                        _a = _b.sent(), count = _a.count, results = _a.results;
                        _i = 0, results_3 = results;
                        _b.label = 3;
                    case 3:
                        if (!(_i < results_3.length)) return [3 /*break*/, 7];
                        result = results_3[_i];
                        return [4 /*yield*/, __await(result)];
                    case 4: return [4 /*yield*/, _b.sent()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 3];
                    case 7:
                        combinedResults = combinedResults.concat(results);
                        total_pages = Math.ceil(count / page_size);
                        page += 1;
                        return [3 /*break*/, 1];
                    case 8: return [4 /*yield*/, __await(combinedResults)];
                    case 9: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    RestApiConnector.prototype.unfurlGenericUnhelpfulPagination = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var page, next, combinedResults, _a, next_page, results;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        page = 1, next = true, combinedResults = [];
                        _b.label = 1;
                    case 1:
                        if (!next) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.request(__assign(__assign({}, options), { params: __assign(__assign({}, options.params), { page: page }), retryPolicy: new RetryPolicy_1.AuthenticatedPaginatedRequestRetryPolicy() }))];
                    case 2:
                        _a = _b.sent(), next_page = _a.next_page, results = _a.results;
                        combinedResults = combinedResults.concat(results);
                        next = !!next_page;
                        page += 1;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, combinedResults];
                }
            });
        });
    };
    RestApiConnector.prototype.iterateGenericUnhelpfulPagination = function (options) {
        return __asyncGenerator(this, arguments, function iterateGenericUnhelpfulPagination_1() {
            var page, next, combinedResults, _a, next_page, results, _i, results_4, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        page = 1, next = true, combinedResults = [];
                        _b.label = 1;
                    case 1:
                        if (!next) return [3 /*break*/, 8];
                        return [4 /*yield*/, __await(this.request(__assign(__assign({}, options), { params: __assign(__assign({}, options.params), { page: page }), retryPolicy: new RetryPolicy_1.AuthenticatedPaginatedRequestRetryPolicy() })))];
                    case 2:
                        _a = _b.sent(), next_page = _a.next_page, results = _a.results;
                        _i = 0, results_4 = results;
                        _b.label = 3;
                    case 3:
                        if (!(_i < results_4.length)) return [3 /*break*/, 7];
                        result = results_4[_i];
                        return [4 /*yield*/, __await(result)];
                    case 4: return [4 /*yield*/, _b.sent()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 3];
                    case 7:
                        combinedResults = combinedResults.concat(results);
                        next = !!next_page;
                        page += 1;
                        return [3 /*break*/, 1];
                    case 8: return [4 /*yield*/, __await(combinedResults)];
                    case 9: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    RestApiConnector.prototype.unfurlStasisApiPagination = function (options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var page, next, combinedResults, response, match;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        page = null, next = true, combinedResults = [];
                        _b.label = 1;
                    case 1:
                        if (!next) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.request(__assign(__assign({}, options), { params: __assign(__assign({}, options.params), { page: page }), retryPolicy: new RetryPolicy_1.AuthenticatedPaginatedRequestRetryPolicy() }))];
                    case 2:
                        response = _b.sent();
                        match = (_a = response.next) === null || _a === void 0 ? void 0 : _a.match(/page=([^&]*)/);
                        if (match) {
                            page = encodeURIComponent(match[1]);
                            next = true;
                        }
                        else {
                            next = false;
                        }
                        combinedResults = combinedResults.concat(response.results);
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, combinedResults];
                }
            });
        });
    };
    return RestApiConnector;
}());
exports.default = RestApiConnector;
